// extracted by mini-css-extract-plugin
module.exports = {"HeaderContainer":"ProjectGuide_HeaderContainer__1uum2","CloseIcon":"ProjectGuide_CloseIcon__pfNgz","ProjectName":"ProjectGuide_ProjectName__32SQd"};